import React from 'react';
import Svg from '../Svg';

const IconGitMerge = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4ZM2 6C2 3.79086 3.79086 2 6 2C8.20914 2 10 3.79086 10 6C10 7.84705 8.74809 9.4017 7.04652 9.86171C7.24201 11.6666 8.04737 13.3611 9.34315 14.6569C10.6389 15.9526 12.3334 16.758 14.1383 16.9535C14.5983 15.2519 16.153 14 18 14C20.2091 14 22 15.7909 22 18C22 20.2091 20.2091 22 18 22C16.1221 22 14.5465 20.7059 14.1162 18.9609C11.788 18.7544 9.59483 17.737 7.92893 16.0711C7.59237 15.7345 7.28228 15.3764 7 15.0001V21C7 21.5523 6.55228 22 6 22C5.44772 22 5 21.5523 5 21V9.87398C3.27477 9.42994 2 7.86384 2 6ZM18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20C19.1046 20 20 19.1046 20 18C20 16.8954 19.1046 16 18 16Z"
    />
  </Svg>
);

export default IconGitMerge;
